import { render, staticRenderFns } from "./TalkizyLogoMark.vue?vue&type=template&id=709fbd4a&scoped=true&"
import script from "./TalkizyLogoMark.vue?vue&type=script&lang=js&"
export * from "./TalkizyLogoMark.vue?vue&type=script&lang=js&"
import style0 from "./TalkizyLogoMark.vue?vue&type=style&index=0&id=709fbd4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709fbd4a",
  null
  
)

export default component.exports